module.exports = __webpack_public_path__ + "img/logoimg.9056a2b0.png";